import FileDownloadIcon from "@mui/icons-material/FileDownload";
import {capitalize, Tooltip} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import {useAufgabenHandling} from "../../hooks/aufgaben/useAufgabenHandling";

interface ButtonExportAuswertungAufgabeProps {
    aufgabeId: string;
}

export default function ButtonExportAuswertungAufgabe({ 
    aufgabeId,
}: ButtonExportAuswertungAufgabeProps) {
    const { translation, handleExport, loadingExport } = useAufgabenHandling();

    return (
        <Tooltip title={translation('export-auswertung')}>
            <LoadingButton
                id={`button-export-auswertung-aufgabe-${aufgabeId}`}
                aria-label={`button-export-auswertung-aufgabe-${aufgabeId}`}
                onClick={() => handleExport(aufgabeId)}
                loading={loadingExport}
                loadingPosition="start"
                startIcon={<FileDownloadIcon />}
                variant="text"
                color="inherit"
            >
                {capitalize(translation('export'))}
            </LoadingButton>
        </Tooltip>
    );
}
